export const statusOptionsExample = {
  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "Active": [
    {
      title: "Edit",
      cls: "edit-dock-door",
      icon: "pencil",
      disabled: false 
    },
    {
      title: "Copy",
      cls: "copy-dock-door",
      icon: "copy",
      disabled: false 
    },
    {
      title: "Deactivate",
      cls: "deactivate-dock-door",
      icon: "toggle-off",
      disabled: false
    },
  ],
  "Inactive": [
    {
      title: "Edit",
      cls: "edit-dock-door",
      icon: "pencil",
      disabled: false 
    },
    {
      title: "Copy",
      cls: "copy-dock-door",
      icon: "copy",
      disabled: false 
    },
    {
      title: "Activate",
      cls: "activate-dock-door",
      icon: "toggle-on",
      disabled: false
    }
  ],
};



// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/html/doorLookup/stores/statusOptions.js